import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import type { Tip } from './types';
import { apiRoutes } from '@/api/api-routes';
import type { TIP_TYPE } from '@/lib/constants';

export type TipsParams = {
  type: TIP_TYPE;
};

export const getTips = async (
  params: TipsParams,
  config?: AxiosRequestConfig
) => {
  const response = await publicHttpClient.get<Tip[]>(
    apiRoutes.master_data.tips,
    {
      params,
      ...config,
    }
  );
  return response.data;
};
